import { FirebaseMessaging } from '@firebase/messaging-types';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { configurationAccess } from 'app/area/user-profile/my-notifications/configuration-access';
import { firebaseConfig, webPushCertificate } from 'app/infrastructure/push/configuration-data';

// eslint:disable:no-console
const registerServiceWorker = async () => {
  const { b64PublicKey } = webPushCertificate;
  const firebase = (await import('@firebase/app')).firebase;
  await import('@firebase/messaging');

  const app = firebase.initializeApp(firebaseConfig);
  const messaging = (app as any).messaging();

  try {
    b64PublicKey && messaging.usePublicVapidKey(b64PublicKey);
    const swRegistration = firebaseConfig && await navigator.serviceWorker
      .register(toAbsoluteUrl('/service-worker.js?' + new URLSearchParams(firebaseConfig)),
        { scope: toAbsoluteUrl('/') });
    swRegistration && messaging.useServiceWorker(swRegistration);

    messaging.onMessage(payload => {
      if (payload && payload.notification) {
        const { notification: { title = '', ...options } } = payload;

        title && options && navigator.serviceWorker.ready.then(registration => {
          registration.showNotification(title, { ...options, data: { redirect_url: payload.notification.click_action } });
        });
      }
    });
  } catch (error) {
    console.error('Service Worker Error', error);
  }
  return messaging;
};

const unregisterServiceWorker = () => {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
};

export const initFmc = async () => {
  let messaging: FirebaseMessaging;
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    if (configurationAccess.push && webPushCertificate) {
      messaging = await registerServiceWorker();
    } else {
      unregisterServiceWorker();
    }
  }

  return messaging;
};
